"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.amPalette = void 0;

/**
 * A Palette of colors for data visualizations
 */
var amPalette = {
  am10: '#F9E3EE',
  am30: '#F8CCE0',
  am60: '#F6A1C5',
  am: '#DF6CA0',
  amDark: '#C82B72',
  amDarkest: '#8B1248'
};
exports.amPalette = amPalette;